export const materials = [
  { name: "Steel (average recycled content)", factor: 2.364 },
  { name: "Steel (85% recycled content)", factor: 1.282 },
  { name: "Galvanised Steel", factor: 2.766 },
  {
    name: "Aluminium General, European Mix, Inc Imports",
    factor: 6.66871753053474,
  },
  { name: "Aluminium, produced in Europe", factor: 5.58393820253815 },
  { name: "Aluminium General, Worldwide", factor: 13.0555399913056 },
  { name: "Aluminium, North American", factor: 5.65161603135555 },
  { name: "Aluminium, Africa", factor: 12.40574989561 },
  { name: "Aluminium, China", factor: 14.5935686562606 },
  { name: "Aluminium, Japan", factor: 10.6245125383474 },
  { name: "Aluminium, Middle East", factor: 10.8098001619353 },
  { name: "Aluminium, Oceania", factor: 12.75208458561 },
  { name: "Aluminium, Other Asia", factor: 15.86909679561 },
  { name: "Aluminium, Russia", factor: 5.54832303360998 },
  { name: "Aluminium, South America", factor: 8.31900055360999 },
  { name: "Aluminium, South Korea", factor: 11.9468532105351 },
  { name: "Paint", factor: 2.91 },
  { name: "Plastics, general", factor: 3.31 },
  { name: "Plastics, ABS", factor: 3.76 },
  { name: "Plastics, HDPE", factor: 1.93 },
  { name: "Plastics, polycarbonate", factor: 7.62 },
  { name: "Timber", factor: 0.493 },
  { name: "Zinc", factor: 3.09 },
  { name: "Copper", factor: 2.71 },
  { name: "Glass", factor: 2.08 },
  { name: "HV Insulator Polymeric", factor: 4.5 },
  { name: "Lubricant Oil", factor: 1.07 },
];

export const transport = [
  { name: "Road", factor: 0.00012481 },
  { name: "Rail", factor: 0.00002556 },
  { name: "Ship", factor: 0.00000903 },
  { name: "Air", factor: 0.00113382 },
];

export const ENERGY_INUSE_FACTOR = 16355.2151;

export const energy = [
  { name: "On site renewables", unit: "kWh", factor: 0.0 },
  { name: "Natural Gas, on site", unit: "kWh (Gross CV)", factor: 0.18387 },
  { name: "Oil, on site", unit: "litres", factor: 2.54039 },
  { name: "Algeria", unit: "kWh", factor: 0.517529215358932 },
  { name: "Angola", unit: "kWh", factor: 0.4 },
  { name: "Argentina", unit: "kWh", factor: 0.370689655172414 },
  { name: "Armenia", unit: "kWh", factor: 0.168831168831169 },
  { name: "Australia", unit: "kWh", factor: 0.798393574297189 },
  { name: "Austria", unit: "kWh", factor: 0.226356589147287 },
  { name: "Azerbaijan", unit: "kWh", factor: 0.5 },
  { name: "Bahrain", unit: "kWh", factor: 0.760617760617761 },
  { name: "Bangladesh", unit: "kWh", factor: 0.581132075471698 },
  { name: "Belarus", unit: "kWh", factor: 0.926984126984127 },
  { name: "Belgium", unit: "kWh", factor: 0.220462850182704 },
  { name: "Benin", unit: "kWh", factor: 0.5 },
  { name: "Bolivia", unit: "kWh", factor: 0.395061728395062 },
  { name: "Bosnia and Herzegovina", unit: "kWh", factor: 0.828571428571429 },
  { name: "Botswana", unit: "kWh", factor: 1.44444444444444 },
  { name: "Brazil", unit: "kWh", factor: 0.13431527266351 },
  { name: "Brunei Darussalam", unit: "kWh", factor: 0.613636363636364 },
  { name: "Bulgaria", unit: "kWh", factor: 0.605568445475638 },
  { name: "Cambodia", unit: "kWh", factor: 0.388888888888889 },
  { name: "Cameroon", unit: "kWh", factor: 0.220588235294118 },
  { name: "Canada", unit: "kWh", factor: 0.160938938324639 },
  { name: "Chile", unit: "kWh", factor: 0.481532147742818 },
  { name: "China", unit: "kWh", factor: 0.806636594408021 },
  { name: "Chinese Taipei", unit: "kWh", factor: 0.58537565287264 },
  { name: "Colombia", unit: "kWh", factor: 0.182380216383308 },
  { name: "Congo", unit: "kWh", factor: 0.222222222222222 },
  { name: "Costa Rica", unit: "kWh", factor: 0.0784313725490196 },
  { name: "Côte d'Ivoire", unit: "kWh", factor: 0.513157894736842 },
  { name: "Croatia", unit: "kWh", factor: 0.285714285714286 },
  { name: "Cuba", unit: "kWh", factor: 0.900523560209424 },
  { name: "Curaçao", unit: "kWh", factor: 0.777777777777778 },
  { name: "Cyprus", unit: "kWh", factor: 0.651162790697675 },
  { name: "Czech Republic", unit: "kWh", factor: 0.650812064965197 },
  { name: "Dem. Rep. of Congo", unit: "kWh", factor: 0 },
  { name: "Denmark", unit: "kWh", factor: 0.487031700288184 },
  { name: "Dominican Republic", unit: "kWh", factor: 0.581920903954802 },
  { name: "DPR of Korea", unit: "kWh", factor: 0.384615384615385 },
  { name: "Ecuador", unit: "kWh", factor: 0.347639484978541 },
  { name: "Egypt", unit: "kWh", factor: 0.441001191895113 },
  { name: "El Salvador", unit: "kWh", factor: 0.241379310344828 },
  { name: "Eritrea", unit: "kWh", factor: 0.75 },
  { name: "Estonia", unit: "kWh", factor: 1.10526315789474 },
  { name: "Ethiopia", unit: "kWh", factor: 0.0 },
  { name: "Finland", unit: "kWh", factor: 0.311360448807854 },
  { name: "France", unit: "kWh", factor: 0.0757842791681354 },
  { name: "Gabon", unit: "kWh", factor: 0.458333333333333 },
  { name: "Georgia", unit: "kWh", factor: 0.0891089108910891 },
  { name: "Germany", unit: "kWh", factor: 0.545584953777494 },
  { name: "Ghana", unit: "kWh", factor: 0.271317829457364 },
  { name: "Gibraltar", unit: "kWh", factor: 0.5 },
  { name: "Greece", unit: "kWh", factor: 0.653239929947461 },
  { name: "Guatemala", unit: "kWh", factor: 0.292929292929293 },
  { name: "Haiti", unit: "kWh", factor: 0.636363636363636 },
  { name: "Honduras", unit: "kWh", factor: 0.271604938271605 },
  { name: "Hungary", unit: "kWh", factor: 0.399339933993399 },
  { name: "Iceland", unit: "kWh", factor: 0.0 },
  { name: "India", unit: "kWh", factor: 4.88165374677003 },
  { name: "Indonesia", unit: "kWh", factor: 0.76113172541744 },
  { name: "Iraq", unit: "kWh", factor: 1.03396739130435 },
  { name: "Ireland", unit: "kWh", factor: 0.434108527131783 },
  { name: "Islamic Rep. of Iran", unit: "kWh", factor: 0.559171597633136 },
  { name: "Israel", unit: "kWh", factor: 0.69449081803005 },
  { name: "Italy", unit: "kWh", factor: 0.386245224036124 },
  { name: "Jamaica", unit: "kWh", factor: 0.619047619047619 },
  { name: "Japan", unit: "kWh", factor: 0.572363986519018 },
  { name: "Jordan", unit: "kWh", factor: 0.635838150289017 },
  { name: "Kazakhstan", unit: "kWh", factor: 0.931865828092243 },
  { name: "Kenya", unit: "kWh", factor: 0.280898876404494 },
  { name: "Korea", unit: "kWh", factor: 0.565904443205057 },
  { name: "Kosovo", unit: "kWh", factor: 0.984615384615385 },
  { name: "Kuwait", unit: "kWh", factor: 0.727868852459016 },
  { name: "Kyrgyzstan", unit: "kWh", factor: 0.121428571428571 },
  { name: "Latvia", unit: "kWh", factor: 0.338709677419355 },
  { name: "Lebanon", unit: "kWh", factor: 0.708791208791209 },
  { name: "Libya", unit: "kWh", factor: 0.574257425742574 },
  { name: "Lithuania", unit: "kWh", factor: 0.571428571428571 },
  { name: "Luxembourg", unit: "kWh", factor: 0.444444444444444 },
  { name: "Malaysia", unit: "kWh", factor: 0.693420101229212 },
  { name: "Malta", unit: "kWh", factor: 0.695652173913044 },
  { name: "Mauritius", unit: "kWh", factor: 0.793103448275862 },
  { name: "Mexico", unit: "kWh", factor: 0.506226859643218 },
  { name: "Mongolia", unit: "kWh", factor: 2.22 },
  { name: "Montenegro", unit: "kWh", factor: 0.384615384615385 },
  { name: "Morocco", unit: "kWh", factor: 0.6415770609319 },
  { name: "Mozambique", unit: "kWh", factor: 0.0134228187919463 },
  { name: "Myanmar", unit: "kWh", factor: 0.19327731092437 },
  { name: "Namibia", unit: "kWh", factor: 0.0769230769230769 },
  { name: "Nepal", unit: "kWh", factor: 0.0 },
  { name: "Netherlands", unit: "kWh", factor: 0.535183349851338 },
  { name: "New Zealand", unit: "kWh", factor: 0.15473441108545 },
  { name: "Nicaragua", unit: "kWh", factor: 0.333333333333333 },
  { name: "Niger", unit: "kWh", factor: 1.25 },
  { name: "Nigeria", unit: "kWh", factor: 0.410344827586207 },
  { name: "North Macedonia", unit: "kWh", factor: 0.836065573770492 },
  { name: "Norway", unit: "kWh", factor: 0.0149588631264024 },
  { name: "Oman", unit: "kWh", factor: 0.572519083969466 },
  { name: "Pakistan", unit: "kWh", factor: 0.416155419222904 },
  { name: "Panama", unit: "kWh", factor: 0.255555555555556 },
  { name: "Peru", unit: "kWh", factor: 0.253456221198157 },
  { name: "Philippines", unit: "kWh", factor: 0.576361221779549 },
  { name: "Poland", unit: "kWh", factor: 0.960975609756098 },
  { name: "Portugal", unit: "kWh", factor: 0.312871287128713 },
  { name: "Qatar", unit: "kWh", factor: 0.495677233429395 },
  { name: "Romania", unit: "kWh", factor: 0.478632478632479 },
  { name: "Russian Federation", unit: "kWh", factor: 0.892114220877458 },
  { name: "Saudi Arabia", unit: "kWh", factor: 0.727112676056338 },
  { name: "Senegal", unit: "kWh", factor: 0.594594594594595 },
  { name: "Serbia", unit: "kWh", factor: 0.821428571428572 },
  { name: "Singapore", unit: "kWh", factor: 0.45625 },
  { name: "Slovak Republic", unit: "kWh", factor: 0.270175438596491 },
  { name: "Slovenia", unit: "kWh", factor: 0.367088607594937 },
  { name: "South Africa", unit: "kWh", factor: 0.92654028436019 },
  { name: "South Sudan", unit: "kWh", factor: 0.8 },
  { name: "Spain", unit: "kWh", factor: 0.247404224847834 },
  { name: "Sri Lanka", unit: "kWh", factor: 0.333333333333333 },
  { name: "Sudan", unit: "kWh", factor: 0.194174757281553 },
  { name: "Sweden", unit: "kWh", factor: 0.0470588235294118 },
  { name: "Switzerland", unit: "kWh", factor: 0.0392441860465116 },
  { name: "Syrian Arab Republic", unit: "kWh", factor: 0.555984555984556 },
  { name: "Tajikistan", unit: "kWh", factor: 0.0 },
  { name: "Thailand", unit: "kWh", factor: 0.509957754978878 },
  { name: "Togo", unit: "kWh", factor: 0.0 },
  { name: "Trinidad and Tobago", unit: "kWh", factor: 0.652631578947369 },
  { name: "Tunisia", unit: "kWh", factor: 0.46195652173913 },
  { name: "Turkey", unit: "kWh", factor: 0.456286427976686 },
  { name: "Turkmenistan", unit: "kWh", factor: 0.962962962962963 },
  { name: "Ukraine", unit: "kWh", factor: 0.670624677336087 },
  { name: "United Arab Emirates", unit: "kWh", factor: 0.599811676082863 },
  { name: "United Kingdom", unit: "kWh", factor: 0.23314 },
  { name: "United Rep. of Tanzania", unit: "kWh", factor: 0.5 },
  { name: "United States", unit: "kWh", factor: 0.496465977746157 },
  { name: "Uruguay", unit: "kWh", factor: 0.11965811965812 },
  { name: "Uzbekistan", unit: "kWh", factor: 0.695571955719557 },
  { name: "Venezuela", unit: "kWh", factor: 0.247564935064935 },
  { name: "Vietnam", unit: "kWh", factor: 0.352755905511811 },
  { name: "Yemen", unit: "kWh", factor: 0.752941176470588 },
  { name: "Zambia", unit: "kWh", factor: 0.0 },
  { name: "Zimbabwe", unit: "kWh", factor: 0.421052631578947 },
  { name: "Other", unit: "kWh", factor: 0.0 },
];

export const categories = [
  ["Busbars", "Busbars", "general", "metre"],
  ["Busbars", "Busbars", "general", "km"],
  ["Cable", "132kV Cable", "132kV", "km"],
  ["Cable", "20kV UG Cable", "HV", "km"],
  ["Cable", "33kV UG Cable", "EHV", "km"],
  ["Cable", "6.6/11kV UG Cable", "HV", "km"],
  ["Cable", "66kV UG Cable", "EHV", "km"],
  ["Cable", "AC submarine cable", "400kV", "km"],
  ["Cable", "Circuit Cable", "General", "km"],
  ["Cable", "EHV Sub Cable", "EHV", "km"],
  ["Cable", "HV Sub Cable", "HV", "km"],
  ["Cable", "LV Main (UG Consac)", "LV", "km"],
  ["Cable", "LV Main (UG Paper)", "LV", "km"],
  ["Cable", "LV Main (UG Plastic)", "LV", "km"],
  ["Cable", "Submarine cable", "220kV", "km"],
  ["Cable", "Submarine cable", "220kV", "km"],
  ["Cable", "Submarine cable", "132kV", "km"],
  ["Cable", "Submarine cable", "275kV", "km"],
  ["Cable", "Submarine cable", "400kV", "km"],
  ["Cable", "Substation Cable - >=3 core per phase", "<=33kV", "km"],
  ["Circuit Breaker", "6.6/11kV CB", "HV", "Each"],
  ["Circuit Breaker", "Switch (GM)", "<=33kV", "Each"],
  ["Circuit Breaker", "Switchgear - Other", "<=33kV", "Each"],
  ["HVDC", "HVDC onshore cable", "HVDC", "km"],
  ["HVDC", "HVDC Overhead Conductor", "HVDC", "km"],
  ["HVDC", "HVDC Subsea Cable", "HVDC", "km"],
  ["Instrument Transformers", "Current Transformer  (CT)", "11kV", "Each"],
  ["Instrument Transformers", "Current Transformer  (CT)", "33kV", "Each"],
  ["Instrument Transformers", "Current Transformer  (CT)", "132kV", "Each"],
  ["Instrument Transformers", "Voltage Transformer  (VT)", "11kV", "Each"],
  ["Instrument Transformers", "Voltage Transformer  (VT)", "33kV", "Each"],
  ["Instrument Transformers", "Voltage Transformer  (VT)", "132kV", "Each"],
  ["LVAC", "Diesel Generators & LVAC Boards", "Per Site"],
  ["LVAC", "LVAC cabling", "0", "km"],
  ["Other switchgear", "Disconnector (AIB)", "132kV", "Each"],
  ["Other switchgear", "Disconnector (AIB)", "275kV", "Each"],
  ["Other switchgear", "Disconnector (AIB)", "400kV", "Each"],
  ["Other switchgear", "Disconnector AIS (OD)", "132kV", "Each"],
  ["Other switchgear", "Disconnector AIS (OD)", "275kV", "Each"],
  ["Other switchgear", "Disconnector AIS (OD)", "400kV", "Each"],
  ["Other switchgear", "Earth Switch AIS (OD)", "132kV", "Each"],
  ["Other switchgear", "Earth Switch AIS (OD)", "275kV", "Each"],
  ["Overhead Line Fittings", "Fittings", "general", "kg"],
  ["Overhead Pole Line", "132kV OHL (Pole Line) Conductor", "132kV", "km"],
  ["Overhead Pole Line", "132kV Pole", "132kV", "Each"],
  ["Overhead Pole Line", "20kV OHL (Conventional Conductor)", "HV", "km"],
  ["Overhead Pole Line", "20kV Poles", "HV", "Each"],
  ["Overhead Pole Line", "33kV OHL Conductor", "EHV", "km"],
  ["Overhead Pole Line", "33kV Pole - Standard Pole", "33kV", "Each"],
  ["Overhead Pole Line", "33kV Pole - Steel Masts", "33kV", "Each"],
  ["Overhead Pole Line", "6.6/11kV OHL (BLX or similar Conductor)", "HV", "km"],
  ["Overhead Pole Line", "6.6/11kV OHL (Conventional Conductor)", "HV", "km"],
  ["Overhead Pole Line", "6.6/11kV Poles", "HV", "Each"],
  ["Overhead Pole Line", "66kV Pole - Standard Pole", "66kV", "Each"],
  ["Overhead Pole Line", "66kV Pole - Steel Masts", "66kV", "Each"],
  ["Overhead Pole Line", "Main (OHL) Conductor", "LV", "km"],
  ["Overhead Pole Line", "LV Poles", "LV", "Each"],
  ["Overhead Pole Line", "Pole", "<=33kV", "Each"],
  ["Overhead Pole Line", "Pole", "132kV", "Each"],
  ["Overhead Pole Line", "Pole", "275kV", "Each"],
  ["Overhead Pole Line", "Pole", "400kV", "Each"],
  ["Overhead Tower Line", "132kV Tower", "132kV", "Each"],
  ["Overhead Tower Line", "33kV Tower", "EHV", "Each"],
  ["Overhead Tower Line", "66kV Tower", "EHV", "Each"],
  ["Overhead Tower Line", "Tower", "400kV", "Each"],
  ["Overhead Tower Line", "Tower", "275kV", "Each"],
  ["Overhead Tower Line", "Tower", "<=33kV", "Each"],
  ["Overhead Tower Line", "Tower", "132kV", "Each"],
  ["Protection", "Pilot Wire Overhead", "Other", "km"],
  ["Protection", "Pilot Wire Underground", "Other", "km"],
  ["Protection & Control", "Fault Recorder with dynamic system monitoring", "general", "Each"],
  ["Protection & Control", "Feeder Protection", "general", "Each"],
  ["Protection & Control", "Substation Control Systems (SCS)", "general", "Each"],
  ["Switchgear", "132kV Switchgear - Other", "132kV", "Each"],
  ["Switchgear", "20kV RMU", "HV", "Each"],
  ["Switchgear", "20kV Switchgear - Other (PM)", "HV", "Each"],
  ["Switchgear", "33kV RMU", "EHV", "Each"],
  ["Switchgear", "33kV Switchgear - Other", "EHV", "Each"],
  ["Switchgear", "6.6/11kV RMU", "HV", "Each"],
  ["Switchgear", "6.6/11kV Switchgear - Other (PM)", "HV", "Each"],
  ["Switchgear", "6.6/11kV X-type RMU", "HV", "Each"],
  ["Switchgear", "66kV Switchgear - Other", "EHV", "Each"],
  ["Switchgear", "LV Board (WM)", "LV", "Each"],
  ["Switchgear", "LV Board (X-type Network) (WM)", "LV", "Each"],
  ["Switchgear", "LV Circuit Breaker", "LV", "Each"],
  ["Switchgear", "LV Pillar (ID)", "LV", "Each"],
  ["Switchgear", "LV Pillar (OD at Substation)", "LV", "Each"],
  ["Switchgear", "LV Pillar (OD not at a Substation)", "LV", "Each"],
  ["Transformer", "132kV Transformer (GM)", "132kV", "Each"],
  ["Transformer", "20kV Transformer (GM)", "HV", "Each"],
  ["Transformer", "20kV Transformer (PM)", "HV", "Each"],
  ["Transformer", "33kV Transformer (GM)", "EHV", "Each"],
  ["Transformer", "33kV Transformer (PM)", "EHV", "Each"],
  ["Transformer", "6.6/11kV Transformer (GM)", "HV", "Each"],
  ["Transformer", "6.6/11kV Transformer (PM)", "HV", "Each"],
  ["Transformer", "66kV Transformer (GM)", "EHV", "Each"],
  ["Wound plant", "Series Reactor", "132kV", "Each"],
  ["Wound plant", "Series Reactor", "132kV", "Each"],
  ["Wound plant", "Series Reactor", "275kV", "Each"],
  ["Wound plant", "Series Reactor", "275kV", "Each"],
  ["Wound plant", "Series Reactor", "400kV", "Each"],
  ["Wound plant", "Series Reactor", "400kV", "Each"],
  ["Wound plant", "Shunt Reactor", "132kV", "Each"],
  ["Wound plant", "Shunt Reactor", "132kV", "Each"],
  ["Wound plant", "Shunt Reactor", "400kV", "Each"],
  ["Wound plant", "Shunt Reactor", "400kV", "Each"],
  ["Wound plant", "Shunt Reactor", "275kV", "Each"],
  ["Wound plant", "Shunt Reactor", "275kV", "Each"],
  ["Wound plant", "Transformer", "132kV>90MVA", "Each"],
  ["Wound plant", "Transformer", "132kV<=90MVA", "Each"],
  ["Wound plant", "Transformer", "132kV<=90MVA", "Each"],
];

export const gas = [{ name: "SF6", factor: 22800 }];
